<template>
    <section class="row flexbox-container">
  <div class="col-xl-8 col-md-9 col-10 d-flex justify-content-center px-0">
      <div class="card bg-authentication rounded-0 mb-0">
          <div class="row m-0">
              <div class="col-lg-6 d-lg-block d-none text-center align-self-center">
                  <img src="/images/pages/forgot-password.png" alt="branding logo">
              </div>
              <div class="col-lg-6 col-12 p-0">
                  <div class="card rounded-0 mb-0 px-2 py-1">
                      <div class="card-header pb-1">
                          <div class="card-title">
                              <h4 class="mb-0">{{trans('auth.logging_in')}}</h4>
                          </div>
                      </div>
                      <div class="card-content">
                          <div class="card-body">
                            <div class="float-md-left d-block mb-1">

                                <router-link to="/login" class="btn btn-outline-primary btn-block px-75">{{trans('auth.back_to_login?')}}</router-link>
                            </div>

                            </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  
</section>
</template>

<script>
    import guestFooter from '../../layouts/guest-footer.vue'

    export default {
        data() {
            return {}
        },
        components: {
            guestFooter
        },
        mounted(){

            if(!helper.featureAvailable('social_login')){
                helper.featureNotAvailableMsg();
                return this.$router.push('/home');
            }

            axios.post('/api/auth/social/token')
                .then(response => response.data)
                .then(response => {
                    localStorage.setItem('auth_token',response.token);
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('auth_token');
                    this.$store.dispatch('setAuthStatus');
                    toastr.success(response.message);
                    this.$router.push('/home');
                }).catch(error => {
                    helper.showDataErrorMsg(error);
                    this.$router.push('/');
                });
        }
    }
</script>
